module.exports = __webpack_public_path__ + "img/icon2.3520c991.png";